<app-header></app-header>
<div class="spinner_overlay" *ngIf="showSpinner()"></div>
<mat-spinner mode="indeterminate" *ngIf="showSpinner()"></mat-spinner>
<router-outlet></router-outlet>
